import React, { FC } from 'react';
import { CSSProperties } from 'styled-components';
import { useHandbook, useHandbookKeys } from '~/controllers/handbook';

interface Props {
  value: string | undefined | null;
}

const LegalTypeField: FC<Props> = (props) => {
  const { value } = props;

  const handbook = useHandbook();
  const handbookKeys = useHandbookKeys();

  if (typeof value !== 'string') return null;

  if (handbook.isLoading) {
    return <span style={loadingStyle}>{value}</span>;
  }

  const localizedValue = handbook.data?.handbooks
    ?.find((item) => item.key === handbookKeys.legalType)
    ?.values?.find((item) => item.apiValue === value)?.localizedValue;
  return <>{localizedValue || value}</>;
};

const loadingStyle: CSSProperties = { opacity: 0.3 };

export default LegalTypeField;
